jQuery(function($){
    $(document.body).removeClass('no-js').addClass('js');

    initPolyfills();

    // Utilities
    //initStickyHeader();
    //initHeader();
    initClassToggle();
    initNumberAnimation();
    initAccordionTabs();
    initAnchorScroll();
    
    initMobileMenu();
    initLoadmoreLot();
    initLoadmorePackage();
    // CF7 Form Control
    //initCF7();
    //initFullheightMobile();
    initProjectPagination();
    initSliderGallery();
    initMobileSlider();
    initBannerLeaf();
    initLotpage();
    inithousepage();
    initParallax();
    ninjaFormMisc();
    
});

function isMobile() {
    return window.matchMedia('(max-width:767px)').matches;
}

function initPolyfills() {
    // CSS object-fit for IE
    objectFitImages();

    // polyfill for IE - startsWith
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    // polyfill for IE - forEach
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
    }
}

// $(window).scroll(function() {
//         changeHeader();
// });

// function changeHeader() {
//     var siteHeader = $('.site-header');
//     var body = $('body');
//     if ($(this).scrollTop() > 120) {
//         if(!siteHeader.hasClass('off-top')){
//             siteHeader.addClass('off-top');
//         }
//     } else{
//         siteHeader.removeClass('off-top');
       
//     }

// }

/*function initHeader() {
   $(window).scroll(function(){
        if($(window).scrollTop() > 40){
            $(".site-header").addClass('off-top');   
        }
        else{
            $(".site-header").removeClass('off-top');
        }

    })
}*/


/**
 * Toggle class on click
 */
function initClassToggle() {
    $(document.body).on('click', '[data-toggle="class"][data-class]', function(event) {
        var $trigger = $(this);
        var thisparent = $('.site-header');
        var $target = $($trigger.data('target') ? $trigger.data('target') : $trigger.attr('href'));
        var $winWidth = $(window).width();
        if($target.length) {
            event.preventDefault();
            $target.toggleClass($trigger.data('class'));
            $trigger.toggleClass('classed');
            if($winWidth <= 1200) {
                thisparent.toggleClass('header-top');
            }
        }
    });
    $('.table__wrapper tr.clickable-row').each(function(){
        $(this).hover(function(){
            $(this).prev().toggleClass('active');
            $(this).toggleClass('active-row');
        });
    });
    
}
function initNumberAnimation() {
    $('.progress-chart__percentage p.large .number').each(function () {
      var $this = $(this);
      var num = $this.data('num');
      var assigned = $this.text(num);
      jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
        duration: 1000,
        easing: 'swing',
        step: function () {
          $this.text(Math.ceil(this.Counter));
        }
      });
    });
    var offset = $('.ring-fill').data('numb');
    var offset_default = $('.ring-default').data('numb');
    $(".ring-fill").animate({"stroke-dashoffset":offset}, 1000);
    $(".ring-default").animate({"stroke-dashoffset":offset_default}, 1000);
}
function initAccordionTabs() {
    const $accordionTabs = $('.accordion-tabs');
    if (!$accordionTabs.length) {
        return;
    }
    function initTabs() {
        const $tabs = $accordionTabs.find('.accordion-tabs__tabs');
        if (!$tabs.length) {
            return;
        }
        const $triggers = $tabs.find('.tabs__link');
        $triggers.each((_, trigger) => {
            $(trigger).on('click', (e) => {
                e.preventDefault();
                const target = $(trigger).data('target');
                if(target && !$(trigger).hasClass('active')) {
                    $(trigger).parent().find('.active').removeClass('active');
                    $(trigger).addClass('active');
                    $tabs.find('.tabs__content.show').removeClass('show');
                    $tabs.find(target).addClass('show');
                }
            })
        })
    }
    initTabs();
}

function initMobileMenu() {
    $('.mobile-menu-toggle a').click(function(e){
        e.preventDefault();
        var thisparent = $(this).closest('header');
        $('.header-main__menu--mobile', thisparent).slideToggle();

    });

    var menuItemWithChildren = $('.menu-item-has-children');
    if(menuItemWithChildren.length) {
        menuItemWithChildren.each(function() {
            var li = $(this);
            var anchor = li.find('> a');

            if(anchor.length) {
                anchor.on('click', function(e) {
                    li.toggleClass('menu-active');
                    e.preventDefault();
                    e.stopPropagation();
                });
            }
        });
    }
}

/**
 * Smooth anchor scrolling
 */
function initAnchorScroll() {
    $('a[href*="#"]:not([data-toggle])').click(function(event) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="'+this.hash.slice(1)+'"]');
            if (target.length && !target.parents('.woocommerce-tabs').length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        }
    });
}

// function initCF7(){
//     var wpcf7Elm = $('.wpcf7-form')[0];
//     var formbtn = $('.wpcf7-form input[type="submit"]');

//     formbtn.on('click', function(){
//         formbtn.val('SENDING...');
//     });

//     document.addEventListener( 'wpcf7invalid', function( event ) {
//         formbtn.val('SUBMIT');
//     }, false );

//     document.addEventListener( 'wpcf7mailsent', function( event ) {
//         formbtn.val('SENT!');
//     }, false );
// }

/*function initFullheightMobile() {
    // Fix mobile 100vh change on address bar show/hide
    var lastHeight = $(window).height();
    var heightChangeTimeout = undefined;
    if(isMobile()) {
        $('.vh').css('height', lastHeight);
    }
    (maybe_update_landing_height = function() {
        var winHeight = $(window).height();

        if(heightChangeTimeout !== undefined) {
            clearTimeout(heightChangeTimeout);
        }

        if(!isMobile()) {
            $('.vh').css('height', '');
        }
        else if(Math.abs(winHeight - lastHeight) > 100) {
            heightChangeTimeout = setTimeout(function() {
                var winHeight = $(window).height();
                $('.vh').css('height', winHeight);
                lastHeight = winHeight;
            }, 50);
        }
    })();
    $(window).resize(maybe_update_landing_height);
}*/

/*function initCopyToClipboard() {
  $(document.body).on('click', '[data-copy-to-clipboard]', function(event) {
    event.preventDefault();

    // Source: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    var el = document.createElement('textarea');
    el.value = $(this).data('copy-to-clipboard');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  });
}*/
function transformPaginationControl($pagination, label, loadedCallback) {
    
    var $currentLink = $pagination.find('.current'); 
    var $nextLink = $pagination.find('a.next');

    if ($currentLink.text().trim() == '1') {
        if ($nextLink) {
            $pagination.html('<a href="' + $nextLink.attr('href') + '" class="pagination__load-more">' + label + '</a>');

            var loadMoreAJAX = undefined;

            $pagination.find('.pagination__load-more').click(function (event) {
                event.preventDefault();

                var $this = $(this);

                if (loadMoreAJAX !== undefined) {
                    return;
                }
                

                $this.addClass('loading');

                loadMoreAJAX = $.ajax({
                    url: $this.attr('href'),
                    method: 'GET',
                    dataType: 'html',
                    context: this,
                    success: function (response) {
                        loadMoreAJAX = undefined;

                        var $response = $(response);

                        var $nextLink = loadedCallback($response);

                        var $loadMore = $(this);

                        if ($nextLink.length) {
                            $loadMore.attr('href', $nextLink.attr('href'));
                            $loadMore.removeClass('loading');
                        } else {
                            $loadMore.remove();
                        }
                    },
                    error: function () {
                        $(this).remove();
                    },
                });
            });
        }
    }
}

// REPLACE THIS FUNCTION WITH SOMETHING APPROPRIATE FOR YOUR CODE
function initProjectPagination() {
    var $pagination = $('.module__post-tiles .pagination');
    if ($pagination.length) {
        transformPaginationControl($pagination, 'Load More News', function ($response) {
            var $products = $response.find('.list-children').children();
            $('.list-children').append($products);

            return $response.find('.module__post-tiles .pagination a.next');
        });
    }
    $('.post__filter-wrapper .cat-list_item').on('click', function(e) {
        e.preventDefault();
      $('.cat-list_item').removeClass('active');
      $(this).addClass('active');

      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
          action: 'filter_projects',
          category: $(this).data('slug'),
        },
        success: function(res) {
          $('.project-tiles').html(res);
        }
      })
    });
}

function initSliderGallery() {
    var tns = window.tns;
    var galleries = document.querySelectorAll('.gallery');

    if(tns && galleries) {
        galleries.forEach(function(galleryContainer) {
            var gallery = galleryContainer.querySelector('.gallery__list');
            var galleryControls = galleryContainer.querySelector('.gallery__controls');
            var galleryNav = galleryContainer.querySelector('.gallery__nav');

            var slider = tns({
                'container': gallery,
                'items': 1,
                'loop': true,
                'mouseDrag': true,
                'swipeAngle': false,
                'nav': true,
                "navContainer": galleryNav,
                'controlsContainer': galleryControls,
            });
        });
    }
}




$(document).on('nfFormReady', function(e, layoutView) {
  var $form = layoutView.$el;
  $form.find('select').select2();
});

$('.medialotImage:first-child').show();
$('.clickable-row').on('click', function(){
    var attrValue = $(this).attr('data-hidden');
    $(".medialotImage").hide();
    $("#" + attrValue).show();
});

 function initLoadmoreLot(){
      var page = 2;
        var post = 3;
        $('#post').append(post);
        jQuery(function($) {
        $('#more_posts').on('click',function(e) {
            e.preventDefault();
            var totalpost = $('#lot_count').val();
            var page_count = $('#page_count').val();
            jQuery.ajax({
                url: _ajaxurl,
                type: 'post',
                data: { action: 'load_more', page: page},

                success: function(data) { 
                    if($.trim(data) != '') {
                        $('#datafetchload').append(data);
                        var ajax_count = $('.ajax_count').text();
                        var totalcount = $('#datafetchload').children().length - $('.ajax_count').length;
                        $('.ajax_count').text(totalcount);
                        $('#post').empty();
                         $('#post').append(totalcount);
                    if(page >= page_count){
                        jQuery('#more_posts').hide();
                    }
                    page = page + 1;
                } else {
                    $('#more_posts').hide();
                }
                        }
            });
        });
    });    
}
function initLoadmorePackage() {
    var page = 2;
    var post = 3;
     $('#packagepost').append(post);
    jQuery(function($)
    {
    $('#more_posts_package').on('click',function(e) {
        e.preventDefault();
        var totalpost = $('#package_count').val();
        var page_count = $('#package_page_count').val();
        jQuery.ajax({
            url: _ajaxurl,
            type: 'post',
            data: { action: 'load_more_package', page: page},
            success: function(data) {                       
                if($.trim(data) != '') {
                    $('#datafetchloadpackage').append(data);
                    var ajax_count = $('.ajax_count_package').text();
                    var totalcount = $('#datafetchloadpackage').children().length - $('.ajax_count_package').length;
                        console.log(totalcount);
                    $('.ajax_count_package').text(totalcount);
                    $('#packagepost').empty();
                     $('#packagepost').append(totalcount);
                if(page >= page_count){
                    jQuery('#more_posts_package').hide();
                }
                page = page + 1;
            } else {
                $('#more_posts_package').hide();
            }
                    }
        });
    });
});
}

$('.banner_slider_wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000
});

//slider
initMobileSlider(".module__related-news__listing .row");
initMobileSlider(".module__related-lot .module__related-lot__listing .row");
function initMobileSlider(widthClass) {
    var winWidth = $(window).width();
    if(winWidth <= 767) {
        $(widthClass).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            arrows: false,
            dots: true,
        });
    }
}
$('.mob-cons-gallery-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    arrows: true,
    dots: true,
});

$('.module__construction-progress--half-left--wrapper.mob-design').on('init afterChange', function(e, slick){
  let currentSlick = $('.slick-current.slick-active', slick.$slideTrack)
  let prevName = currentSlick.prev().data('slide-name')
  let nextName = currentSlick.next().data('slide-name')
  
  slick.$prevArrow.text(prevName)
  slick.$nextArrow.text(nextName)
});

$('.module__construction-progress--half-left--wrapper.mob-design').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    loop: true,
    infinite: true
});

//Load more news
$(document).ready(function(){
        var ppp = 6; // Post per page
        var pageNumber = 1;
        $(".pagination__load-more").on("click",function(){ // When btn is pressed.
            $(".pagination__load-more").attr("disabled",true); // Disable the button, temp.
            var totalCount = $('.project-tiles').data("id");
            var postLength = $(".project-tiles .news_lists").length;
            var trimlength = totalCount - postLength;
             if(trimlength <= 6){ 
                $(".pagination").hide(); 
             }
            load_posts();
        });
    function load_posts(){
        pageNumber++;
        var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=load_more_news';
        $.ajax({
            type: "POST",
            dataType: "html",
            url: '/wp-admin/admin-ajax.php',
            data: str,
            success: function(data){
                var $data = $(data);
                //alert($data.length)
                if($data.length!=0){
                    $("#loadData").append($data);
                    $(".pagination__load-more").attr("disabled",false);
                } else{
                    $(".pagination__load-more").hide();
                }
            },
            error : function(jqXHR, textStatus, errorThrown) {
                $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            }

        });
        return false;
    }

    $('.cat-list li a').click(function(){
        $(".pagination").show(); 
        var currentCat = $(this).attr('data-slug');
        $('.cat-list li a').removeClass('active');
        $(this).addClass('active');
        $('#currentData').hide();
        $("#loadData").html('');
        var pgnum = 1;
        load_postssss(currentCat,pgnum);
    });


    $(".pagination__load-more_cat").on("click",function(){ // When btn is pressed.
            $(".pagination__load-more_cat").attr("disabled",true); // Disable the button, temp.
            var currentCat = '';
            var tabObj = $('.cat-list').find('li');
            console.log(tabObj)
            tabObj.each(function(){
                if(($(this).find('a').hasClass('active'))){
                    currentCat = $(this).find('a').attr('data-slug');
                }
            });
            
            setTimeout(function(){  
                var lastItem = $("#loadData .news_lists:last-of-type").data('tile'); 
                if(lastItem < 6){
                     $(".pagination").hide(); 
                }
            }, 1000);
            var newpgnum = $('#loadmorepagination').val();
           load_postssss(currentCat,newpgnum);
        });
    
    function load_postssss(currentCat,pgnum){
        
        var str = '&cat=' + currentCat + '&pageNumber=' + pgnum + '&ppp=' + ppp + '&action=load_more_news_cat';
        $.ajax({
            type: "POST",
            dataType: "html",
            url: '/wp-admin/admin-ajax.php',
            data: str,
            success: function(data){
                var $data = $(data);
                //alert($data.length)
                if($data.length!=0){
                    $('#currentData').hide();
                $("#loadData").append($data);
                $(".pagination__load-more").hide();
                $(".pagination__load-more_cat").show();
                //alert(pgnum);
                var cpage = parseInt(pgnum)+1;
                //alert("cpage"+cpage);
                $('#loadmorepagination').val('');
                $('#loadmorepagination').val(cpage);
                } else{
                $(".pagination__load-more").hide();
                $(".pagination__load-more_cat").hide();
                $('#loadmorepagination').val('1');
                }
            },
            error : function(jqXHR, textStatus, errorThrown) {
                $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            }

        });
        return false;
    }
}); 

function initBannerLeaf() {
    if (window.location.href.indexOf('/lot_') > 0) {
       //$('.page-banner .banner__leaf-container').css('display','none');
       $('body').addClass('lot__detail__packages');
       $('.section-masterplan .Insite-App').css('padding-bottom','55px');
    }
    
}


function initLotpage(){
  setTimeout(function () {
    $('.section-house-and-land .hal-stage-ahref').on('click',function(e){
        e.preventDefault();
        $('body').addClass('house-and-land__detail');
    });
    },1500);
}
function inithousepage() {
    var loc = window.location.href; // returns the full URL
  if(/package/.test(loc)) {
    $('body').addClass('house-and-land__packages');
  }
  setTimeout(function () {
    $('.section-masterplan .lfsd-stage-lotblock .i-table').on('click',function(){
        $('body').addClass('lot__detail');
    });
    },4000);
}


function initParallax() {
    var $bg = $('.parallax');
    var factor = 0.8;
    function resizeParalax() {
        var offsetTop = $bg.parent().offset().top;
        var parallaxing = function() {
            var pageScroll = window.pageYOffset;
            var scroll = (pageScroll - offsetTop) * factor;
            $bg.css('top', scroll + 'px')
        }
        window.removeEventListener('scroll', parallaxing);
        window.addEventListener('scroll', parallaxing);
    }
    resizeParalax();
    window.addEventListener('resize', resizeParalax);
}


function ninjaFormMisc() {

$(document).on('nfFormSubmitResponse', (event, { response: { data } }) => {
    window.dataLayer = window.dataLayer || []
        if (data.settings.key !== 'send_to_third_parties') {
            return true
        }

    const { first_name, last_name, email, phone, postcode, source_of_enquiry } = data.fields_by_key;

    const fields = {
        first_name: first_name.value,
        last_name: last_name.value,
        email: email.value,
        phone: phone.value,
        postcode: postcode.value,
        source_of_enquiry: source_of_enquiry.value,
        form_title: data.settings.title
    }
    window.dataLayer.push({
        event: 'formSubmission',
        webformData: fields,
        formId: data.settings.title
        });
    })
}



$(function() {
  function sort_li(a, b) {
      return ($(b).data('position')) === ($(a).data('position')) ? 1 : ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
  }
  $(".like-select li.sorts-list").sort(sort_li).prependTo('.like-select');
});

var dropdown = document.getElementsByClassName("dropdown-list");
var attribute;
var myFunction = function() {
attribute = this.getAttribute("data-target");
    var x = document.getElementById(attribute);
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
  
};
for (var i = 0; i < dropdown.length; i++) {
    dropdown[i].addEventListener('click', myFunction, false);
}




